<template>
  <div class="system module-wrapper">
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "Statistics",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  // created () {},
  // beforeMount () {},
  // mounted () {},
  // components: {},
  // watch: {}
};
</script>

<style lang="scss" scoped></style>
